import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import { PATHS } from 'routes/constants';

export const PastDueBanner: FC = () => {
	const navigate = useNavigate();
	return (
		<Toolbar
			disableGutters
			sx={{
				backgroundColor: '#de000024',
				color: '#000000d0',
				fontStyle: 'italic',
				padding: '0 5px 0px 15px',
				zIndex: 1000,
				'@media (min-width: 600px)': {
					minHeight: '56px',
				},
			}}
		>
			<span>
				<b>Your account is past due.</b> To avoid issues accessing and using your account, make a
				payment. If you&rsquo;ve already paid, please note it may take a few days to process.
				{window.location.pathname !== PATHS.INVOICES_PAGE && (
					<Button
						variant="contained"
						color="primary"
						size="small"
						sx={{
							ml: 2,
							mb: '3px',
							mt: '3px',
							textTransform: 'none',
							fontSize: '.7rem',
							fontWeight: 600,
							borderRadius: '12px',
						}}
						onClick={() => navigate(PATHS.INVOICES_PAGE)}
					>
						Pay now
					</Button>
				)}
			</span>
		</Toolbar>
	);
};
